import {Component, computed, input} from '@angular/core';
import {NgClass} from '@angular/common';
import {BadgeType, BADGE_CONFIG} from './module-function-status-badge.types';

@Component({
  selector: 'app-module-function-status-badge',
  imports: [NgClass],
  templateUrl: './module-function-status-badge.component.html',
})
export class ModuleFunctionStatusBadgeComponent {
  type = input.required<BadgeType>();

  config = computed(() => BADGE_CONFIG[this.type()]);
}
